import { Component, Input, OnInit } from '@angular/core';
import { PrismicService } from 'src/app/_services/prismic.service';

@Component({
  selector: 'app-plans-overview',
  standalone: false,
  templateUrl: './plans-overview.component.html',
  styleUrls: ['./plans-overview.component.scss']
})
export class PlansOverviewComponent implements OnInit {

  @Input() plan: any;

  constructor(private prismicService: PrismicService) { }

  ngOnInit(): void {
  }

  getHtml(content) {
    return this.prismicService.getHtml(content);
  }

}
